import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Ensure the blockId route parameter is a valid number
export const blockIdGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const idString = route.paramMap.get('blockId');

  // Reject null/empty/whitespace values
  if (idString === null || idString.trim() === '') {
    return router.createUrlTree(['/tracking/blocks']);
  }

  const id = Number(idString); 

  // If the blockId parameter is not a valid number, redirect back to block summary
  if (Number.isNaN(id) || !Number.isInteger(id) || id < 0) {
    return router.createUrlTree(['/tracking/blocks']); 
  }

  return true;
};
